import { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { estadoColor } from "../utils/estadoColor";
import Card from "../components/ui/Card";
import Badge from "../components/ui/Badge";
import Btn from "../components/ui/Btn";
import Input from "../components/ui/Input";
import Table from "../components/ui/Table";
import SectionHeader from "../components/ui/SectionHeader";
import { exportarPDF } from "../utils/exporters";

export default function ModuloAuditorias({ auditorias, onNotify }) {
  const { puede } = useAuth();
  const [filtroMod, setFiltroMod] = useState("Todos");
  const [buscar, setBuscar] = useState("");

  // ✅ Verificación de permisos ANTES de renderizar
  if (!puede("ver_auditorias")) {
    return (
      <Card className="access-denied">
        <p className="text-lg mb-2">🔒 Acceso restringido</p>
        <p className="text-muted">No tenés permiso para ver auditorías</p>
      </Card>
    );
  }

  const modulos = ["Todos", ...new Set(auditorias.map(a => a.modulo).filter(Boolean))];
  const filtradas = auditorias.filter(a =>
    (filtroMod === "Todos" || a.modulo === filtroMod) &&
    (a.accion?.toLowerCase().includes(buscar.toLowerCase()) || a.usuario?.toLowerCase().includes(buscar.toLowerCase()))
  );

  return (
    <div>
      <SectionHeader title="Auditorías y trazabilidad" action={
        <Btn 
        variant="success" 
        small 
        onClick={() => exportarPDF(
          "Registro de Auditorías", 
          ["Fecha", "Usuario", "Acción", "Módulo", "Estado"], 
          auditorias.map(a => [a.fecha, a.usuario, a.accion, a.modulo, a.estado]),
          "auditorias"
        )}
      >
        📥 Exportar PDF
      </Btn>
      } />
      
      <div className="flex gap-2 mb-3 flex-wrap">
        <Input value={buscar} onChange={e => setBuscar(e.target.value)} placeholder="🔍 Buscar acción o usuario..." className="flex-1 min-w-45" />
        <div className="flex gap-1 flex-wrap">
          {modulos.map(m => <Btn key={m} small variant={filtroMod === m ? "primary" : "default"} onClick={() => setFiltroMod(m)}>{m}</Btn>)}
        </div>
      </div>
      
      <Card>
        <Table
          cols={["Fecha/Hora", "Usuario", "Acción", "Módulo", "Resultado"]}
          rows={filtradas.map(a => [
            <span className="text-xs text-muted whitespace-nowrap">{a.fecha}</span>,
            <span>{a.usuario}</span>,
            <span>{a.accion}</span>,
            <Badge color="muted">{a.modulo}</Badge>,
            <Badge color={estadoColor(a.resultado)}>{a.resultado}</Badge>,
          ])}
        />
      </Card>
    </div>
  );
}